// Animate menu
let primaryMenuList = document.getElementById("primary-menu");
let primaryMenuItems =  primaryMenuList.children;

for (let i = 0; i < primaryMenuItems.length; i++) {
    let timeInterval = 'animation-delay:' + (2.5+(i*.2)) + 's;';
    primaryMenuItems[i].style.cssText += timeInterval;
    primaryMenuItems[i].classList.toggle('animateItem');
}

// Fade-in on Content
let elementsToFade = document.querySelectorAll(".fade-tile");
window.addEventListener('scroll', fadeElements ); 
function fadeElements() {
    for (var i = 0; i < elementsToFade.length; i++) {
        var elem = elementsToFade[i]
        var distInView = elem.getBoundingClientRect().top - window.innerHeight + 100;
        if (distInView < 0) {
            elem.classList.add("inView");
        } else {
            elem.classList.remove("inView");
        }
    }
}
fadeElements();

// Scroll Timer
// var wasScrolled = false;
// window.onscroll = function () {
//     wasScrolled = true;
// }
// function doSmoothScrollToAnchor() {
//     if(wasScrolled === false) {
//         alert("Was not scrolled");
//     } else {
//         alert("The user scrolled manually");
//     }
// }
// setTimeout(doSmoothScrollToAnchor, 3000);